import { Badge, Table, Spinner } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';
import { getAuthHeader } from '../../utils/tools';
import { PLAN_LIMITS } from '../../config/plans';

const STATUS_CONFIG = {
    succeeded: { label: 'Úspešná',  variant: 'success' },
    pending:   { label: 'Čakajúca', variant: 'warning' },
    failed:    { label: 'Neúspešná', variant: 'danger' },
};

const formatEur = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')} €`;

const formatDate = (date) =>
    new Date(date).toLocaleDateString('sk-SK', { day: '2-digit', month: '2-digit', year: 'numeric' });

const PaymentHistory = ({ history }) => {
    const [downloadingId, setDownloadingId] = useState(null);
    const [downloadError, setDownloadError] = useState(null);

    const handleDownload = async (payment) => {
        setDownloadingId(payment._id);
        setDownloadError(null);
        try {
            const response = await axios.get(
                `/api/payment/${payment._id}/invoice`,
                { ...getAuthHeader(), responseType: 'blob' }
            );
            const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.download = `faktura-${payment.superfakturaInvoiceNo || payment._id}.pdf`;
            link.click();
            URL.revokeObjectURL(url);
        } catch {
            setDownloadError('Faktúru sa nepodarilo stiahnuť. Kontaktujte podporu.');
        } finally {
            setDownloadingId(null);
        }
    };

    if (!history?.length) return null;

    return (
        <div className="mt-4">
            {downloadError ? (
                <div style={{ marginBottom: '12px', padding: '10px 16px', backgroundColor: '#FFF5F5', border: '1px solid #FC8181', borderRadius: '8px', fontSize: '14px', color: '#C53030' }}>
                    {downloadError}
                </div>
            ) : null}
            <h6 style={{ color: '#0B1157', fontWeight: 700, marginBottom: '16px' }}>
                História platieb
            </h6>
            <div className="rounded" style={{ border: '1px solid #EDF2F7', overflow: 'hidden' }}>
                <Table responsive className="mb-0" style={{ backgroundColor: '#fff' }}>
                    <thead style={{ backgroundColor: '#F4F5FE' }}>
                        <tr>
                            <th style={{ fontWeight: 600, fontSize: '13px', padding: '12px 16px' }}>Dátum</th>
                            <th style={{ fontWeight: 600, fontSize: '13px', padding: '12px 16px' }}>Plán</th>
                            <th style={{ fontWeight: 600, fontSize: '13px', padding: '12px 16px' }}>Platnosť</th>
                            <th style={{ fontWeight: 600, fontSize: '13px', padding: '12px 16px' }}>Suma</th>
                            <th style={{ fontWeight: 600, fontSize: '13px', padding: '12px 16px' }}>Stav</th>
                            <th style={{ fontWeight: 600, fontSize: '13px', padding: '12px 16px' }}>Faktúra</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((payment) => {
                            const status = STATUS_CONFIG[payment.status] || STATUS_CONFIG.pending;
                            const isDownloading = downloadingId === payment._id;
                            return (
                                <tr key={payment._id}>
                                    <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                                        {formatDate(payment.createdAt)}
                                    </td>
                                    <td style={{ padding: '12px 16px', fontSize: '14px' }}>
                                        {PLAN_LIMITS[payment.plan]?.label ?? payment.plan}
                                    </td>
                                    <td style={{ padding: '12px 16px', fontSize: '14px', whiteSpace: 'nowrap' }}>
                                        {payment.periodStart && payment.periodEnd
                                            ? `${formatDate(payment.periodStart)} – ${formatDate(payment.periodEnd)}`
                                            : '—'}
                                    </td>
                                    <td style={{ padding: '12px 16px', fontSize: '14px', fontWeight: 600 }}>
                                        {formatEur(payment.amount)}
                                    </td>
                                    <td style={{ padding: '12px 16px' }}>
                                        <Badge bg={status.variant} style={{ fontSize: '12px', padding: '4px 10px' }}>
                                            {status.label}
                                        </Badge>
                                    </td>
                                    <td style={{ padding: '12px 16px' }}>
                                        {payment.superfakturaInvoiceId ? (
                                            <button
                                                onClick={() => handleDownload(payment)}
                                                disabled={isDownloading}
                                                style={{
                                                    background: 'none',
                                                    border: '1px solid #0B1157',
                                                    borderRadius: '8px',
                                                    padding: '4px 12px',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    color: '#0B1157',
                                                    cursor: isDownloading ? 'default' : 'pointer',
                                                    opacity: isDownloading ? 0.6 : 1,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                }}
                                            >
                                                {isDownloading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : 'Stiahnuť'}
                                            </button>
                                        ) : '—'}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default PaymentHistory;
